// extracted by mini-css-extract-plugin
module.exports = {"NearbyZones":"Nearbyzones_NearbyZones__2dkVt","fade":"Nearbyzones_fade__2xMGu"};